import { UserService } from '@duck/api-definitions'
import { useAuth } from './useAuth'
import { useUserBadges } from './useUserBadges'

export const useCanUsePython = (): boolean => {
  const { isAdmin } = useAuth()
  const { hasBadge } = useUserBadges()
  return isAdmin || hasBadge(UserService.UserBadge.AlphaTester)
}
